import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { allSalestargetdetailsView } from "./grphql";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

const ViewYearlyTarget = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await request(BASEURL, allSalestargetdetailsView);
      setData(res?.allSalesTarget);
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleEdit = (id) => {
    navigate(`/SalesTarget/updateSalesTarget?${id}`);
  };
  return (
    <DashboardLayout>
      <div>
        {data?.map((v, i) => {
          return (
            <div>
              <div>
                <table className="montable">
                  <thead>
                    <tr className="montr">
                      <th className="month">Finacial Year</th>
                      <th className="month">Target Maximum Amount</th>
                      <th className="month">Target Minimum Amount</th>
                      <th className="month">Action</th>
                    </tr>
                  </thead>
                  <tbody className="month">
                    <tr className="montr">
                      <td className="montd">{v?.financialyearStart}</td>
                      <td className="montd">{v?.maximumAmount}</td>
                      <td className="montd">{v?.minimumAmount}</td>
                      <td className="montd">
                        <Button onClick={() => handleEdit(v?.id)}>Edit</Button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <table key={i} className="montable">
                <thead>
                  <tr className="montr">
                    <th className="month">S.NO</th>
                    <th className="month">Name</th>
                    <th className="month">Target Amount</th>
                  </tr>
                </thead>
                <tbody className="month">
                  {v?.salestargetSet?.map((v, i) => {
                    return (
                      <tr key={i} className="montr">
                        <td>{i + 1}</td>
                        <td className="montd">{v?.user?.username}</td>

                        <td className="montd"><CurrencyRupeeIcon />{v?.targetAmount}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    </DashboardLayout>
  );
};

export default ViewYearlyTarget;
